import { useTranslation } from 'react-i18next';
import type { ToolResultBlock } from '../../../store/chatStore';
import { readMovedToolOutput } from '../moved-tool-output';

interface Props {
  result: ToolResultBlock;
}

// A table renderer would read this as an empty result and say nothing was found.
export const MovedOutputRenderer = ({ result }: Props) => {
  const { t } = useTranslation('pleri/chat');
  const moved = readMovedToolOutput(result.content);

  return (
    <div className="p-4 text-sm text-slate-600 dark:text-slate-400">
      {moved?.location
        ? t('movedToolOutputSaved', { location: moved.location })
        : t('movedToolOutputRemoved')}
    </div>
  );
};
